import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de message alert
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
    selector: 'app-element-campagne-marketing',
    templateUrl: './element-campagne-marketing.component.html',
    styleUrls: ['./element-campagne-marketing.component.scss']
})
export class ElementCampagneMarketingComponent extends BaseComponent implements OnInit {
    private nomCookie: string = 'user-preferences';
    private preferences: any;

    estVisible: boolean;

    @Input() nomCampagne: string = '';
    @Input() domaineCampagne: string = '';
    @Input() dateDebutCampagne: string = '';
    @Input() dateFinCampagne: string = '';
    @Input() imageCampagneDesktop: string = '';
    @Input() imageCampagneMobile: string = '';
    @Input() imageBase64: string = '';
    @Input() urlCampagne: string = '';

    /**
     * Constructeur
     */
    constructor(private sanitizer: DomSanitizer) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        var currentDate = new Date();
        this.estVisible = new Date(this.dateDebutCampagne) <= currentDate && currentDate < new Date(this.dateFinCampagne);
        if (this.estVisible) {
            this.preferences = this.obtenirPreferences();
            if (this.preferences && this.preferences.campagne && this.preferences.campagne[this.nomCampagne] != undefined) {
                this.estVisible = this.preferences.campagne[this.nomCampagne]
            }
        }
    }

    get estDomaineCible() {
        if (this.domaineCampagne) {
            return window.location.host == this.domaineCampagne || window.location.host.endsWith('.' + this.domaineCampagne);
        }

        return true;
    }

    get codeImageBase64(){
        if(this.imageBase64){
            return this.imageBase64;
        }
    }

    get urlImageDesktopSanitized() {
        if (this.imageCampagneDesktop) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(this.imageCampagneDesktop);
        }
    }

    get urlImageMobileSanitized() {
        if (this.imageCampagneMobile) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(this.imageCampagneMobile);
        }
    }

    get urlCampagneSanitized() {
        if (this.urlCampagne) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(this.urlCampagne);
        }
    }
    
     public fermer() {
        this.estVisible = false;

        if (!this.preferences.campagne) {
            this.preferences.campagne = {};
        }
        this.preferences.campagne[this.nomCampagne] = this.estVisible;
        
        this.enregistrerPreferences(this.preferences);
    }
    
    public obtenirPreferences() {
        let cookie = this.getCookie(this.nomCookie);
        if (cookie) {
            try {
                return JSON.parse(cookie);
            }
            catch{}
        }
        return {};
    }

    public goto() {
        if (this.urlCampagne) {
            window.open(this.urlCampagne, "_blank");
        }
    }

    private enregistrerPreferences(preferences) {
        this.setCookie(this.nomCookie, JSON.stringify(preferences));
    }

    private setCookie(name: string, val: string) {
        const date = new Date();
        const value = val;

        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));

        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }

    private getCookie(name: string) {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");

        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
    }
}
